import { PortalTooltip } from "../../../common/components/tooltip/PortalTooltip";
import { useSafeId } from "../../../common/components/tooltip/hooks/useSafeId";
import styles from "../AiAssistantPage.module.scss";

interface IAiUsageMeterProps {
  /** 0..100 */
  percent: number;
  /** "12%" */
  label: string;
  /** "1 ноември" */
  resetDateLabel: string;
}

/** How much of the studio's monthly AI budget is used: a quiet line under the title. */
export const AiUsageMeter = ({ percent, label, resetDateLabel }: IAiUsageMeterProps) => {
  const tooltipId = useSafeId("ai-usage");
  const text = `Използвани ${label} от месечния лимит`;
  // Phones have no room for the whole sentence next to the header buttons.
  const shortText = `${label} от лимита`;
  const tooltip = `Лимитът се подновява на ${resetDateLabel}`;

  return (
    <>
      <div
        className={`${styles.meter} ${tooltipId}`}
        role="meter"
        aria-label="Месечен лимит на AI асистента"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(percent)}
        aria-valuetext={`${text}. ${tooltip}.`}
        tabIndex={0}
      >
        <span className={styles.meter_track} aria-hidden="true">
          <span className={styles.meter_fill} style={{ width: `${Math.max(2, percent)}%` }} />
        </span>
        <span className={styles.meter_text} aria-hidden="true">
          {text}
        </span>
        <span className={styles.meter_text_short} aria-hidden="true">
          {shortText}
        </span>
      </div>
      <PortalTooltip anchorSelect={`.${tooltipId}`} place="bottom" positionStrategy="fixed" className={styles.meter_tooltip}>
        {tooltip}
      </PortalTooltip>
    </>
  );
};
